import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildClickUIElementEvent = (inputProperties, currentPage) => ({
    ...inputProperties,
    type: 'Engagement',
    action: 'Click',
    object: Promise.resolve(currentPage).then((page) => ({
        page,
        ...inputProperties.object,
        navigationType: getNavigationType(),
        type: 'UIElement',
        url: window.location.href,
    })),
    ...(inputProperties.metrics && { metrics: inputProperties.metrics }),
    ...(inputProperties.experiments && {
        experiments: inputProperties.experiments,
    }),
});
//# sourceMappingURL=event-builder.js.map